import React, { useEffect, useState } from 'react';

import { SP_COOKIE_BANNER_EVENTS } from 'Utilities/analytics/analyticsCookieBanner';
import { EVENT } from 'Utilities/analytics/optimizely/constants';
import { useOptimizelyTrack } from 'Utilities/analytics/optimizely/useOptimizelyTrack';
import { useIsEmbeddedView } from 'Utilities/hooks/useIsEmbeddedView';

import { CookieBanner } from './CookieBanner';
import { ACCEPT_ALL_CONSENT, COOKIE_POLICY_PATH, ESSENTIALS_ONLY_CONSENT } from './cookieConsent.constants';
import { applyConsent, hasStoredConsent } from './cookieConsent.helpers';

import styles from './CookieConsent.module.scss';

export const CookieConsent = () => {
  const isEmbeddedView = useIsEmbeddedView();
  const { OPTIMIZELY_TRACK } = useOptimizelyTrack();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasStoredConsent());
  }, []);

  const handleAcceptAll = () => {
    SP_COOKIE_BANNER_EVENTS.ACCEPT_ALL_CLICKED();
    OPTIMIZELY_TRACK(EVENT.COOKIE_BANNER_ACCEPT_ALL_CLICKED);
    applyConsent(ACCEPT_ALL_CONSENT);
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    SP_COOKIE_BANNER_EVENTS.ESSENTIAL_ONLY_CLICKED();
    OPTIMIZELY_TRACK(EVENT.COOKIE_BANNER_ESSENTIAL_ONLY_CLICKED);
    applyConsent(ESSENTIALS_ONLY_CONSENT);
    setVisible(false);
  };

  const handleLearnMore = () => {
    SP_COOKIE_BANNER_EVENTS.LEARN_MORE_CLICKED(COOKIE_POLICY_PATH);
    OPTIMIZELY_TRACK(EVENT.COOKIE_BANNER_LEARN_MORE_CLICKED);
  };

  if (!visible || isEmbeddedView) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <CookieBanner
        onAcceptAll={handleAcceptAll}
        onEssentialOnly={handleEssentialOnly}
        onLearnMore={handleLearnMore}
      />
    </div>
  );
};
